import { DragEvent, FC, useState, useContext, useEffect } from 'react';
import { styles } from './DragAndDrop.styles';
import { CloudUpload } from '@mui/icons-material';
import { Typography, Stack } from '@mui/material';
import { LocalizationContext } from 'src/Context/LocalizationContext';

interface DragDropFileProps {
	uploadFiles: (files: File[]) => void;
	parentRef: any;
	activateParentDropArea: (isDragActive: boolean) => void;
	setOnFileDrag?: (onFileDrag: boolean) => void;
}

export const DragDropFile: FC<DragDropFileProps> = ({
	uploadFiles,
	parentRef,
	setOnFileDrag,
	activateParentDropArea,
}) => {
	const [dragActive, setDragActive] = useState(false);

	const { FileUpload } = useContext(LocalizationContext);
	const { DragAndDropDropFilesHere } = FileUpload;

	useEffect(() => {
		activateParentDropArea(dragActive);
	}, [dragActive]);

	const handleDrag = (e: DragEvent<HTMLDivElement | HTMLFormElement>) => {
		e.preventDefault();
		e.stopPropagation();
		if (e.type === 'dragenter' || e.type === 'dragover') {
			setDragActive(true);
		} else if (e.type === 'dragleave') {
			setDragActive(false);
		}
	};

	const handleDrop = (e: DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
		setDragActive(false);
		if (e.dataTransfer.files) {
			uploadFiles(Array.from(e.dataTransfer.files));
		}
	};

	const { fileFormUpload, dragFileElement, dragActiveStyle, labelFileUpload } = styles as any;

	useEffect(() => {
		if (setOnFileDrag) setOnFileDrag(dragActive);
	}, [dragActive]);

	const clientWidth = parentRef.current?.clientWidth || 100;
	const clientHeight = parentRef.current?.clientHeight || 100;

	return (
		<form
			style={{
				...fileFormUpload,
				zIndex: dragActive ? '1' : '0',
				width: parentRef.current?.clientWidth,
				height: dragActive ? clientHeight : clientHeight / 2,
				top: parentRef.current?.offsetTop,
				right: parentRef.current?.offsetRight,
				left: parentRef.current?.offsetLeft,
			}}
			onDragEnter={handleDrag}
			onSubmit={(e) => e.preventDefault()}>
			<label style={{ ...(dragActive && dragActiveStyle), ...labelFileUpload }} />
			{dragActive && (
				<div
					style={{
						...dragFileElement,
						width: clientWidth,
						height: clientHeight,
					}}
					onDragEnter={handleDrag}
					onDragLeave={handleDrag}
					onDragOver={handleDrag}
					onDrop={handleDrop}>
					<Stack alignItems={'center'} justifyContent={'center'}>
						<Typography color={'#BDBDBD'} fontSize={35}>
							{DragAndDropDropFilesHere || 'Drop files here'}
						</Typography>
						<CloudUpload sx={{ color: '#BDBDBD' }} fontSize={'large'} />
					</Stack>
				</div>
			)}
		</form>
	);
};
